import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Lot} from '../models/lot';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {Product} from '../models/product';
import {MatTableDataSource} from '@angular/material/table';
import { firstValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProductLotService {

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  public productLotsDataSource: MatTableDataSource<any>;

  public currentProductLot: Lot;
  public currentProduct: Product;

  public arrayCategories: any[];

  constructor (private db: AngularFirestore,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService) { }


  setEdit (): any {
    if (this.currentProductLot.id) {
      this.isEdit = true
      this.localTitle = this.currentProductLot.name
    } else {
      this.isEdit = false;
      this.localTitle = "Novo Produto"
    }
  }

  loadProductLots (id, _sort) {

    return this.db.collection<Lot>('sbccv_product_lots', ref => ref
      .where('product_id', '==', id)).snapshotChanges()
      .subscribe((result) => {
        let array = result.map(item => {
          let lot = new Lot();
          lot.id = item.payload.doc.id;
          lot.name = item.payload.doc.data().name;
          lot.product_id = item.payload.doc.data().product_id;
          lot.until_date = item.payload.doc.data().until_date;
          return lot;
        });

        this.productLotsDataSource = new MatTableDataSource(array);

        this.productLotsDataSource.connect().next(array);
        this.productLotsDataSource.sort = _sort;

        this.productLotsDataSource.sort.active = "until_date"
        this.productLotsDataSource.sort.direction = "asc"
        this.productLotsDataSource.sort.disableClear = true;

        this.productLotsDataSource.filter = ""

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Load Product Lots error", '', 'error');
        })
  }

  loadLots (id) {
    return this.db.collection<Lot>('sbccv_product_lots', ref => ref
      .where('product_id', '==', id))
      .get();
  }

  async canInsert(productLot: Lot): Promise<boolean> {
    const querySnapshot = await firstValueFrom(this.db.collection<Lot>('sbccv_product_lots', ref => ref
      .where('product_id', '==', productLot.product_id)
      .where('until_date', '==', productLot.until_date)).get());
    return querySnapshot.empty;
  }


  insert (productLot) {
    delete productLot.id
    this.spinner = true;

    return this.db.collection('sbccv_product_lots').add(Object.assign({}, productLot))
      .then((result) => {
        this.isEdit = true;
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        return result.id
      })
      .catch((error) => {
        console.log("insert product lot error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }


  update (productLot) {

    let id = productLot.id
    delete productLot.id
    this.spinner = true;

    return this.db.collection('sbccv_product_lots').doc(id).set(Object.assign({}, productLot))
      .then((result) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("insert product lot error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  delete (lot_id: any) {
    this.spinner = true;
    return this.db.collection('sbccv_product_lots').doc(lot_id).delete()
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("delete lot error" + error)
        this.snackBar.openSnackBar("Erro ao apagar lote", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })

  }

  makeMsgError (errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

  createForm (data) {

    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      product_id: new FormControl('', [ Validators.required ]),
      until_date: new FormControl('', [ Validators.required ])
    });

    if (data.id) {
      form.controls.id.setValue(data.id);
      form.controls.name.setValue(data.name);
      form.controls.product_id.setValue(data.product_id);
      form.controls.until_date.setValue(new Date(data.until_date.seconds * 1000));
    } else {
      form.controls.product_id.setValue(this.currentProduct.id);
    }

    //console.log("this.currentProduct: " + JSON.stringify(this.currentProduct))

    // console.log(JSON.stringify(form.value))
    return form
  }
}

